export function Email({ ...rest }) {
  return (
    <svg {...rest} viewBox="0 0 22 22" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.66667 18.3333C3.16111 18.3333 2.72917 18.1535 2.37083 17.7938C2.0125 17.434 1.83333 17.0014 1.83333 16.4958V5.50417C1.83333 4.99861 2.0125 4.566 2.37083 4.20625C2.72917 3.84653 3.16111 3.66667 3.66667 3.66667H18.3333C18.8389 3.66667 19.2708 3.84653 19.6292 4.20625C19.9875 4.566 20.1667 4.99861 20.1667 5.50417V16.4958C20.1667 17.0014 19.9875 17.434 19.6292 17.7938C19.2708 18.1535 18.8389 18.3333 18.3333 18.3333H3.66667ZM11 11.9167L3.66667 7.33333V16.5H18.3333V7.33333L11 11.9167ZM11 10.0833L18.3333 5.5H3.66667L11 10.0833ZM3.66667 7.33333V5.5V16.5V7.33333Z"
        fill="#666666"
      />
    </svg>
  );
}
